import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import { BindingSignaler } from 'aurelia-templating-resources';
import { autoinject, observable } from 'aurelia-framework';
import { applicationLogger } from "../logging/logger";
import * as Enumerable from "linq-es2015";
import { TemperatureEvents } from "../events/temperature-events";
import { TemperatureScales } from "../converters/temperature-value";

@autoinject
export class TemperatureScaleSelector {

  private readonly i18N: I18N;
  private readonly bindingSignaler: BindingSignaler;
  private readonly eventAggregator: EventAggregator;
  private scales: any[];
  @observable selectedScale: any;

  constructor(bindingSignaler: BindingSignaler, eventAggregator: EventAggregator) {
  
    this.bindingSignaler = bindingSignaler;
    this.eventAggregator = eventAggregator;
    this.configureScales();
    this.selectedScale = this.getSelectedScale();
    applicationLogger.debug("Selected scale: " + this.selectedScale);
  }

  getSelectedScale()  {
    let scale = localStorage.getItem("temperature-scale");
    if (!scale) {
      scale = TemperatureScales.fahrenheit;
    }
    return this.getScale(scale);
  }

  getScale(name: string) {
    const enumerable = Enumerable.AsEnumerable(this.scales);
    return enumerable.FirstOrDefault(scale => scale.name === name);
  }

  selectedScaleChanged() {
    localStorage.setItem("temperature-scale", this.selectedScale.name);
    this.eventAggregator.publish(TemperatureEvents.temperatureScaleChanged, this.selectedScale.name);
  }

  configureScales() {
    this.scales = [
      { name: TemperatureScales.celsius },
      { name: TemperatureScales.fahrenheit }
    ];
  };
}